/**
 * Componente de botón de micrófono (click-to-record)
 * Click para iniciar grabación, click para detener y enviar
 */

import { useVoiceRecorder } from '../../hooks/useVoiceRecorder';
import './MicrophoneButton.css';

interface MicrophoneButtonProps {
  onRecordingComplete?: (audioBlob: Blob) => void;
}

export function MicrophoneButton({ 
  onRecordingComplete
}: MicrophoneButtonProps) {
  const { isRecording, startRecording, stopRecording } = useVoiceRecorder();

  const handleClick = async () => {
    try {
      if (!isRecording) {
        // Iniciar grabación
        await startRecording();
      } else {
        // Detener grabación y enviar
        const audioBlob = await stopRecording();
        if (audioBlob && onRecordingComplete) {
          onRecordingComplete(audioBlob);
        }
      }
    } catch (error) {
      // console.error('Error al manejar grabación:', error);
    }
  };

  return (
    <button
      className={`microphone-button ${isRecording ? 'recording' : ''}`}
      onClick={handleClick}
      aria-label={isRecording ? 'Click para detener y enviar' : 'Click para grabar'}
      title={isRecording ? 'Detener y enviar audio' : 'Grabar audio'}
    >
      <img 
        src="/assets/chat-ui/Microfono_On.png" 
        alt="Micrófono" 
        className="mic-icon"
      />
      {isRecording && (
        <div className="recording-indicator">
          <img 
            src="/assets/chat-ui/Mic_audio.png" 
            alt="Grabando" 
            className="audio-icon"
          />
        </div>
      )}
    </button>
  );
}


